import gql from 'graphql-tag';

export default gql`
  mutation createOrder($input: OrderInput!) {
    createOrder(input: $input) {
      id
      tickets {
        ticketTypeId
      }
      paymentForm
      totalValue
      bankSlipUrl
      bankSlipDueDate
      grandTotalValue
    }
  }
`;



// WEBPACK FOOTER //
// ./src/site-render/src/graphql/mutations/createOrder.js